import { dispatch } from 'store'
import { aiAvatarThunks } from 'store/features/aiAvatar/thunks'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import AvatarActionFlyoutButton from '../flyout/AvatarActionFlyoutButton'
import AvatarActionFlyoutPanel from '../flyout/AvatarActionFlyoutPanel'
import { useSourceImageModel } from './useSourceImageModel'
import * as Styled from './styled'

const EnhanceAvatarButton = () => {
  const { cost } = useSourceImageModel()

  return (
    <AvatarActionFlyoutButton
      icon={<Styled.EnhanceIcon />}
      tooltipText={translate(T.ENHANCE_QUALITY_LABEL)}
      testId="avatar-preview-enhance"
    >
      {close => (
        <AvatarActionFlyoutPanel
          title={translate(T.ENHANCE_QUALITY_LABEL)}
          description={translate(T.ENHANCE_QUALITY_DESCRIPTION)}
          ctaLabel={translate(T.ENHANCE_LABEL)}
          cost={cost}
          onConfirm={() => {
            close()
            dispatch(aiAvatarThunks.enhanceAvatarImage())
          }}
        />
      )}
    </AvatarActionFlyoutButton>
  )
}

export default EnhanceAvatarButton
